import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { AuthenticationService } from '../authentication.service';
import { HeaderService } from '../signin/header.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../_models/user';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { OrganisationService } from "../create-organisation/organisation.service";
import { UserAgentApplication } from 'msal';
import { MsalService } from '@azure/msal-angular';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AlertService } from "../components/alert/alert.service";
import { DamserviceService } from "../dam/damservice.service";
import { WindowRefService } from "../services/window-ref.service";
import AOS from 'aos';

@Component({
  selector: 'app-offer-appsumo',
  templateUrl: './offer-appsumo.component.html',
  styleUrls: ['./offer-appsumo.component.css']
})
export class OfferAppsumoComponent implements OnInit {

  title = 'Offers sign up | Workspace | Crafttor';

  returnUrl: any;
  user_from: string;
  currentUser: User;
  mobileView: boolean = false;

  socialLoginSection: boolean = true;
  tellUsMoreSection: boolean = false;
  mobileViewSection: boolean = false;
  login: boolean = false;
  emailVerify: boolean = true;
  signup: boolean = false;
  forgotpassword: boolean = false;
  forgotpasswordFields: boolean = false;
  enterOtp: boolean = false;
  resetPassword: boolean = false;

  submitted: Boolean = false;
  submitt: Boolean = false;
  submittedForm: Boolean = false;
  submittion: Boolean = false;
  emailVerifySubmit: Boolean = false;
  passwordSubmit: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;
  workspace_token: string;
  emailId: string;
  emailIds: string;
  couponCodeValue: string;
  forgotPasswordErrorMsg: string;
  resetPasswordErrorMsg: string;
  loginErrorMsg: string;
  selectRoleTitle: string = "Founder";
  showGoogleLoginLoader: boolean = false;
  showCouponLeaveLoader: boolean = false;
  showLeaveLoader: boolean = false;
  showTellUsLoader: boolean = false;
  tellUsMoreSectionErrorMsg: any;
  showTellUsMoreSectionError: boolean = false;
  signUpFormFilled: boolean = false;
  fromScreen: any;
  screenToken: any;
  userForgotEmail: any;

  couponErrorMessage: string;
  isShowCouponError: boolean = false;
  nonUniqueCoupons: boolean = false;

  sendSuccessfulMsg: boolean = false;
  successfullMessage: string;
  showTopRightLoader: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;

  userAgentApplication: any;
  userData: any;

  enterCouponCodeStyle = "none";
  userDataDetails: any;
  userPhoto: string;

  isMobile: any;

  public lat;
  public lng;

  filledCount: number = 0;
  filledGoogleCount: number = 0;

  loginForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    password: ['', Validators.required],
  });

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  enterOtpForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  emailVerifyForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  showPasswordError: boolean = false;

  signUpForm = this.fb.group({
    fname: ['', Validators.required],
    lname: ['', Validators.required],
    password: ['', Validators.required],
    otp: ['', Validators.required],
    coupon: [''],
    coupon2: [''],
    coupon3: [''],
  });

  createCoupon = this.fb.group({
    message: ['', Validators.required],
    coupon2: [''],
    coupon3: [''],
  });

  resetPasswordForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  enterNewDetails = this.fb.group({
    organization: [''],
    phoneNumber: [''],
    roleTitle: [''],
  });

  constructor(
    private router: Router,
    private organisationService: OrganisationService,
    private authService: AuthService,
    private activateRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private headerService: HeaderService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    private msalService: MsalService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private cdr: ChangeDetectorRef,
    private alert: AlertService,
    private damService: DamserviceService,
    private windowRefService: WindowRefService
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  public siteKey?: string = '6Lf59_gUAAAAAEJNHrHp1Vdd1LaG1epuOF62yj80';
  public token?: string;
  public siteKeyV2: string = "6Lf4BvkUAAAAAKreyepy8vMm4ttzZtXIY_0xVJ0O";

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor digital assets management is a trendy and awesome file manager. You can store, organise and tag your assets in an attractive manner. Hurry up, sign up today!'},
      { name: 'keywords', content: 'login. workspace, login crafttor, login digital assets managment, digital assets management, dam, DAM' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    if (this.isMobile) {
      this.mobileViewSection = true;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.mobileView = false;
    }

    this.activateRoute.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];
      this.user_from = params['from'];
      this.workspace_token = params['token'];
      if(this.user_from){
        this.headerService.setUserFromSession(this.user_from);
      }
    });

    this.authService.authState.subscribe((user) => {
      if (user && !this.authenticationService.currentUserValue) {
        this.openCouponCodeDialog(user, user.photoUrl);
      }
    });

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (this.currentUser) {
      this.listWorkspace();
      // this.authenticationService.logout();
      // this.authService.signOut();
    }

    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    this.signUpForm.valueChanges.subscribe(values => {
      this.updateCouponCounts(values);
    });

    this.createCoupon.valueChanges.subscribe(values => {
      this.updateGoogleCouponCounts(values);
    });

    // this.windowRefService.getPosition().then(pos=> {
    //   console.log(`Positon: ${pos.lng} ${pos.lat}`);
    // });

    this.getLocation();
    this.getFromScreenDetails();
  }

  getFromScreenDetails() {
    var fromScreenDetails = JSON.parse(localStorage.getItem('loginPaymentDetails'));
    this.fromScreen = fromScreenDetails.fromScreen;
    this.screenToken = fromScreenDetails.screenToken;
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  loginOutlook(){
    this.msalService.loginPopup()
      .subscribe({
        next: (result) => {
          // console.log("Result data accessToken : "+result.accessToken);
          // console.log("Result data uniqueId : "+result.email);
          this.authenticationService.login('microsoft', result.uniqueId,
          result.accessToken, '', '', '', '', this.lat, this.lng, this.workspace_token)
            .subscribe(
              (_data) => {
                // if (this.returnUrl) {
                //   this.router.navigate([this.returnUrl]);
                // }
                // this.router.navigate(['/dam']);
                this.listWorkspace();
              }
            );
        },
        error: (error) => console.log(error)
      });
  }

  public tokenReceivedCallback(errorDesc, token, error, tokenType) {
        if (token) {
            this.userData = token;
            // console.log("Token: " + token)
        } else {
            console.log(error + ":" + errorDesc);
        }
    }

    public microsoftSignIn() {
        var graphScopes = ["user.read", "mail.send"];
        let that = this;

        that.userAgentApplication.loginPopup(graphScopes).then(function(idToken) {
            //Login Success
            that.userAgentApplication.acquireTokenSilent(graphScopes).then(function(accessToken) {

                // console.log(accessToken)
                //AcquireTokenSilent Success
                var headers = new Headers();
                var bearer = "Bearer " + accessToken;
                headers.append("Authorization", bearer);
                var options = {
                    method: "GET",
                    headers: headers
                };
                var graphEndpoint = "https://graph.microsoft.com/v1.0/me";

                fetch(graphEndpoint, options)
                    .then(function(response) {

                        response.json().then(function(data) {
                            that.userData = data;

                            // console.log(data)
                        })
                    })
            }, function(error) {
                //AcquireTokenSilent Failure, send an interactive request.
                that.userAgentApplication.acquireTokenPopup(graphScopes).then(function(accessToken) {
                    //updateUI();
                }, function(error) {
                    console.log(error);
                });
            })
        }, function(error) {
            //login failure
            console.log(error);
        });
    }

  signInWithGoogle(): void {
    if(this.currentUser){
      this.logOut();
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
    }else{
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
    }
  }

  signInWithFB(): void {
    // this.authService.signIn(FacebookLoginProvider.PROVIDER_ID)
    // .then((user) => this.loginToServer(user, user.photoUrl, this.workspace_token));
  }

  socialLogin(){
    this.socialLoginSection = true;
    this.tellUsMoreSection = false;
  }

  fbSignOut(): void {
    this.authService.signOut();
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/login']);
  }

  loginToServer(user: any = null, photoUrl: string, workspace_token: string,
    coupon: any, couponTwo: any, couponThree: any) {
      this.nonUniqueCoupons = false;
      this.isShowCouponError = false;
    const couponOne = coupon;
    const couponTwos = couponTwo;
    const couponThrees = couponThree;
    if ((couponOne && couponOne === couponTwos) ||
    (couponOne && couponOne === couponThrees) ||
    (couponTwos && couponTwos === couponThrees)) {
      this.nonUniqueCoupons = true;
    } else {
      this.nonUniqueCoupons = false;
      this.showTopRightLoader = true;
      this.showCouponLeaveLoader = true;
      this.isShowCouponError = false;
      this.authenticationService.offerLogin(user.provider.toLowerCase(),
      user.id, user.authToken, user.email, user.firstName, user.lastName,
      photoUrl, this.lat, this.lng, workspace_token, coupon, couponTwo, couponThree,
      this.filledGoogleCount, "appsumo")
        .subscribe(
          (_data) => {
            this.showCouponLeaveLoader = false;
            this.showTopRightLoader = false;
            this.socialLoginSection = true;
            this.listWorkspace();
          },
          (error) => {
            if(error.status == 400){
              this.showCouponLeaveLoader = false;
              this.showTopRightLoader = false;
              this.socialLoginSection = true;
              this.isShowCouponError = true;
              this.couponErrorMessage = error.error.message;
            } else {
              this.showCouponLeaveLoader = false;
              this.showTopRightLoader = false;
              this.socialLoginSection = true;
              this.isShowCouponError = true;
              this.couponErrorMessage = error.error.message;
            }
        });
    }
  }

  listWorkspace(){
    this.organisationService.getWorkspaceList().subscribe((data: any) => {
      this.showGoogleLoginLoader = false;
      if(data.length > 0){
        localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data[0].id,
          workspaceName: data[0].title }));
        this.router.navigate(['/dam']);
      }else{
        localStorage.setItem('workspaceCreationScreenDetails', JSON.stringify({ screenId: 2}));
        this.router.navigate(['/create-workspace']);
      }
    });
  }

  loginFunction(){
    this.submitted = true;
    this.loginErrorMsg = "";
    if (this.loginForm.valid) {
      this.showLeaveLoader = true;
        this.authenticationService.loginWithEmail(this.loginForm.value.email, this.loginForm.value.password, this.workspace_token).subscribe((data) => {
          this.showLeaveLoader = false;
          this.submitted = false;
          this.loginForm.reset()
          this.listWorkspace();
        },
        (error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            errors[key].map((message) => {
              this.loginErrorMsg = message;
              this.submitted = false;
              this.showLeaveLoader = false;
            })
          })
       })
    }
  }

  signUpNextFuntion() {
    if (this.signUpForm.valid) {
      this.showGoogleLoginLoader = false;
      this.socialLoginSection = false;
      this.tellUsMoreSection = false;
      this.login = false;
      this.emailVerify = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = true;
      this.emailVerifySubmit = false;
      this.signUpFormFilled = true;
    }
  }

  signUpBackFuntion() {
    this.showGoogleLoginLoader = false;
    this.socialLoginSection = true;
    this.tellUsMoreSection = false;
    this.login = false;
    this.emailVerify = false;
    this.forgotpassword = false;
    this.forgotpasswordFields = false;
    this.enterOtp = false;
    this.resetPassword = false;
    this.signup = true;
    this.emailVerifySubmit = false;
  }

  checkPasswordLength() {
    if(this.signUpForm.value.password.length < 8) {
      this.showPasswordError = true;
    } else {
      this.showPasswordError = false;
      this.signUpFormFunction();
    }
  }

  signUpFormFunction(){
    this.submitt = true;
    this.nonUniqueCoupons = false;
    this.isShowCouponError = false;
    if (this.signUpForm.valid) {
      const couponOne = this.signUpForm.value.coupon;
      const couponTwo = this.signUpForm.value.coupon2;
      const couponThree = this.signUpForm.value.coupon3;
      if ((couponOne && couponOne === couponTwo) ||
      (couponOne && couponOne === couponThree) ||
      (couponTwo && couponTwo === couponThree)) {
        this.nonUniqueCoupons = true;
      } else {
        this.nonUniqueCoupons = false;
        this.showLeaveLoader = true;
        this.showTellUsMoreSectionError = false;
        this.authenticationService.offerRegisterWithEmail(this.signUpForm.value.fname,
          this.signUpForm.value.lname, this.emailIds, this.signUpForm.value.password,
          this.signUpForm.value.otp, this.signUpForm.value.coupon,
          this.signUpForm.value.coupon2, this.signUpForm.value.coupon3, "appsumo", this.filledCount,
          this.enterNewDetails.value.organization, this.enterNewDetails.value.phoneNumber,
          this.selectRoleTitle, this.lat, this.lng, this.workspace_token)
          .subscribe(
            (_data) => {
              // this.isShowCouponError = false;
              this.submitt = false;
              this.showLeaveLoader = false;
              this.showTellUsLoader = false;
              this.signUpForm.reset();
              this.enterNewDetails.reset();
              this.socialLoginSection = false;
              this.tellUsMoreSection = false;
              this.signUpFormFilled = false;
              this.listWorkspace();
            },
            (error) => {
              if(error.status == 400){
                this.sendSuccessfulErrorMsg = true;
                this.sendSuccessfulErrorMessage = error.error.message;
                this.hideSuccesfullFunction();
                // this.showTellUsMoreSectionError = true;
                // this.tellUsMoreSectionErrorMsg = message;
                this.submitt = false;
                this.showTellUsLoader = false;
                this.showLeaveLoader = false;
              } else {
                this.sendSuccessfulErrorMsg = true;
                this.sendSuccessfulErrorMessage = error.error.message;
                this.hideSuccesfullFunction();
                // this.showTellUsMoreSectionError = true;
                // this.tellUsMoreSectionErrorMsg = message;
                this.submitt = false;
                this.showTellUsLoader = false;
                this.showLeaveLoader = false;
              }
          });
      }
    }
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.sendSuccessfulMsg = false;
      this.sendSuccessfulErrorMsg = false;
      this.showTellUsMoreSectionError = false;
      this.submitt = false;
      this.showTellUsLoader = false;
      this.showLeaveLoader = false;
    }, 3000);
  }

  resendOTP() {
    this.sendOTPFunction();
  }

  getOTP(){
    this.emailVerifySubmit = true;
    this.emailIds = this.emailVerifyForm.value.email;
    if (this.emailVerifyForm.valid) {
      this.showLeaveLoader = true;
      this.sendOTPFunction();
    }
  }

  sendOTPFunction() {
    this.damService.getOTP(this.emailVerifyForm.value.email).subscribe((data: any) => {
      this.sendSuccessfulMsg = true;
      this.successfullMessage = "OTP sent successfully!";
      this.hideSuccesfullFunction();
      this.showLeaveLoader = false;
      this.emailVerifyForm.reset();
      this.login = false;
      this.emailVerify = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = true;
      this.emailVerifySubmit = false;
      this.signUpForm.reset();
    },
    (error) => {
      const errors = error.error || error.statusText;
      Object.keys(errors).map((key) => {
        errors[key].map((message) => {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = message;
          this.hideSuccesfullFunction();
          this.emailVerifySubmit = false;
          this.showLeaveLoader = false;
        })
      })
    });
  }

  forgotPasswordFunction(){
    this.submittedForm = true;
    this.forgotPasswordErrorMsg = "";
    if (this.forgotPasswordForm.valid) {
      this.showLeaveLoader = true;
      this.userForgotEmail = this.forgotPasswordForm.value.email;
      this.damService.getResetPasswordOTP(this.forgotPasswordForm.value.email).subscribe((data: any) => {
        this.sendSuccessfulMsg = true;
        this.successfullMessage = "OTP sent Successfully!";
        this.hideSuccesfullFunction();
        this.forgotPasswordForm.reset();
        this.showLeaveLoader = false;
        this.login = false;
        this.signup = false;
        this.forgotpassword = false;
        this.enterOtp = true;
        this.resetPassword = true;
        this.submittedForm = false;
      },
      (error) => {
        const errors = error.error || error.statusText;
        Object.keys(errors).map((key) => {
          // console.log("finally revealed" + errors[key]);
          errors[key].map((message) => {
            this.forgotPasswordErrorMsg = message;
            this.submittedForm = false;
            this.showLeaveLoader = false;
          })
        })
     });
    }
  }

  resetPasswordFunction(){
    this.passwordSubmit = true;
    this.resetPasswordErrorMsg = "";
    if (this.enterOtpForm.valid) {
      this.showLeaveLoader = true;
      this.damService.resetPassword(this.userForgotEmail, this.enterOtpForm.value.otp,
        this.enterOtpForm.value.password, this.enterOtpForm.value.repassword).subscribe((data: any) => {
          this.sendSuccessfulMsg = true;
          this.successfullMessage = "Password reset Successfully!";
          this.hideSuccesfullFunction();
          this.enterOtpForm.reset();
          this.showLeaveLoader = false;
          this.passwordSubmit = false;
          this.enterOtpForm.reset()
          this.forgotPasswordForm.reset()
          this.login = true;
          this.signup = false;
          this.forgotpassword = false;
          this.enterOtp = false;
          this.resetPassword = false;
        },
        (error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            errors[key].map((message) => {
              this.resetPasswordErrorMsg = message;
              this.passwordSubmit = false;
              this.showLeaveLoader = false;
            })
          })
       });
      }
    }

    showLoginScreen() {
      this.loginErrorMsg = "";
      this.resetPasswordErrorMsg = "";
      this.showLeaveLoader = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.emailVerify = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.login = true;
    }

    showEmailVerifyScreen() {
      this.resetPasswordErrorMsg = "";
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.login = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.emailVerify = true;
    }

    showSignUpScreen() {
      this.resetPasswordErrorMsg = "";
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.login = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.emailVerify = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.signup = true;
    }

    forgotScreen(){
      this.resetPasswordErrorMsg = "";
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.loginForm.reset();
      this.login = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = false;
      this.emailVerify = false;
      this.forgotpasswordFields = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.forgotpassword = true;
    }

    showResetPasswordScreen() {
      this.resetPasswordErrorMsg = "";
      this.loginErrorMsg = "";
      this.showLeaveLoader = false;
      this.login = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.emailVerify = false;
      this.signup = false;
      this.passwordSubmit = false;
      this.submittedForm = false;
      this.emailVerifySubmit = false;
      this.submitt = false;
      this.submitted = false;
      this.resetPassword = true;
    }

    selectedRoleTitle(event: any) {
      this.selectRoleTitle = event.target.value;
    }

    openCouponCodeDialog(user: any = null, photoUrl: string) {
      this.userDataDetails = user;
      this.userPhoto = photoUrl;
      this.enterCouponCodeStyle = "block";
    }

    closeCouponCodeDialog() {
      this.enterCouponCodeStyle = "none";
      this.loginToServer(this.userDataDetails, this.userPhoto,
        this.workspace_token, "", "", "");
    }

    submitCouponWithGoogleLogin(couponCode: any, couponCodeTwo: any,
      couponCodeThree: any) {
      this.loginToServer(this.userDataDetails, this.userPhoto,
        this.workspace_token, couponCode, couponCodeTwo, couponCodeThree);
    }

    private updateCouponCounts(values: any) {
      const coupons = [values.coupon, values.coupon2, values.coupon3];
      this.filledCount = coupons.filter(coupon => coupon && coupon.trim() !== '').length;
    }

    private updateGoogleCouponCounts(values: any) {
    const coupons = [values.message, values.coupon2, values.coupon3];
    this.filledGoogleCount = coupons.filter(coupon => coupon && coupon.trim() !== '').length;
  }

  clickTermsAndCondtions() {
    this.router.navigate(['/terms']);
  }
}
